import { toast, ToastContainer, ToastContainerProps, ToastOptions } from 'react-toastify'

// Utility functions to show different types of toasts
export const showToast = {
  success: (message: string, options?: ToastOptions) =>
    toast.success(message, {
      ...options,
      className: 'bg-success-50 text-gray-800 border border-solid border-success-200 rounded-md shadow-md',
    }),
  error: (message: string, options?: ToastOptions) =>
    toast.error(message, {
      ...options,
      className: 'bg-negative-50 text-gray-800 border border-solid border-negative-200 rounded-md shadow-md',
    }),
  info: (message: string, options?: ToastOptions) =>
    toast.info(message, {
      ...options,
      className: 'bg-gray-50 text-gray-800 border border-solid border-gray-200 rounded-md shadow-md',
    }),
  warning: (message: string, options?: ToastOptions) =>
    toast.warn(message, {
      ...options,
      className: 'bg-warning-50 text-gray-800 border border-solid border-warning-200 rounded-md shadow-md',
    }),
}

interface ToastManagerProps extends ToastContainerProps {}

export const ToastManager = (props: ToastManagerProps) => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      {...props} // Allow overriding default props
    />
  )
}
